// components/OcrRow.jsx
import React from "react";

export default function OcrRow({
  row,
  idx,
  selectedRow,
  setSelectedRow,
  setSelectedSymbol,
  hoveredColumn,
  setHoveredColumn,
  td,
  divider,
  getCellStyle,
}) {
  const handleClick = () => {
    setSelectedRow(idx);
    setSelectedSymbol(row.symbol);
  };

  const renderOcrCells = (positions, values, prefix, colorLimit = 5) =>
    positions?.slice(0, 10).map((pos, i) => (
      <td
        key={i}
        className={`col-${prefix}`}
        style={{ ...td, ...getCellStyle(4 + i) }}
        onMouseEnter={() => setHoveredColumn(prefix)}
        onMouseLeave={() => setHoveredColumn(null)}
      >
        {/* TOP: ocr_position[i] */}
        <span style={{ color: pos <= colorLimit ? "#0033cc" : "inherit" }}>
          {pos}
        </span>

        {/* BOTTOM: position_values[i] */}
        <div style={{ fontSize: "11px", color: "#777" }}>
          {values?.[i] !== undefined ? `(${values[i].toFixed(3)})` : "(—)"}
        </div>
      </td>
    ));

  // ✅ helper for % display
  const renderPercent = (value) =>
    Number.isFinite(value) ? (
      <span
        style={{
          color: value > 0 ? "#16a34a" : value < 0 ? "#dc2626" : "#999",
          fontWeight: "600",
        }}
      >
        {value.toFixed(2)}%
      </span>
    ) : (
      "—"
    );

  return (
    <tr
      onClick={handleClick}
      style={{ ...td, cursor: "pointer" }}
      onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#f0f8ff")}
      onMouseLeave={(e) =>
        (e.currentTarget.style.backgroundColor =
          selectedRow === idx ? "#e6f7ff" : "")
      }
    >
      {/* SYMBOL */}
      <td
        style={{ ...td, width: "120px", transition: "color 0.2s" }}
        onMouseEnter={(e) => (e.currentTarget.style.color = "#0077ff")}
        onMouseLeave={(e) => (e.currentTarget.style.color = td.color || "black")}
      >
        {row.symbol}
      </td>

      {/* NAME */}
      <td
        style={{ ...td, width: "220px", transition: "color 0.2s" }}
        onMouseEnter={(e) => (e.currentTarget.style.color = "#0077ff")}
        onMouseLeave={(e) => (e.currentTarget.style.color = td.color || "black")}
      >
        {row.name}
      </td>

      {/* DAILY */}
      <td style={td}>{row.daily_close ?? "—"}</td>

      <td
        style={td}
        onMouseEnter={() => setHoveredColumn("daily")}
        onMouseLeave={() => setHoveredColumn(null)}
      >
        {renderPercent(row.daily_percent)}
      </td>

      {renderOcrCells(
        row.daily_ocr_position,
        row.daily_position_values,
        "daily",
        3
      )}

      {/* 3H */}
      <td style={{ ...td, ...divider }}>{row.hour3_close ?? "—"}</td>

      <td
        style={td}
        onMouseEnter={() => setHoveredColumn("h3")}
        onMouseLeave={() => setHoveredColumn(null)}
      >
        {renderPercent(row.hour3_percent)}
      </td>

      {renderOcrCells(row.hour3_ocr_position, row.hour3_position_values, "h3")}

      {/* 2H */}
      <td style={{ ...td, ...divider }}>{row.hour2_close ?? "—"}</td>

      <td
        style={td}
        onMouseEnter={() => setHoveredColumn("h2")}
        onMouseLeave={() => setHoveredColumn(null)}
      >
        {renderPercent(row.hour2_percent)}
      </td>

      {renderOcrCells(row.hour2_ocr_position, row.hour2_position_values, "h2")}

      {/* 1H */}
      <td style={{ ...td, ...divider }}>{row.hourly_close ?? "—"}</td>

      <td
        style={td}
        onMouseEnter={() => setHoveredColumn("h1")}
        onMouseLeave={() => setHoveredColumn(null)}
      >
        {renderPercent(row.hourly_percent)}
      </td>

      {renderOcrCells(row.hourly_ocr_position, row.hourly_position_values, "h1")}

      {/* WEEKLY */}
      <td style={{ ...td, ...divider }}>{row.weekly_close ?? "—"}</td>

      <td
        style={td}
        onMouseEnter={() => setHoveredColumn("weekly")}
        onMouseLeave={() => setHoveredColumn(null)}
      >
        {renderPercent(row.weekly_percent)}
      </td>

      {renderOcrCells(
        row.weekly_ocr_position,
        row.weekly_position_values,
        "weekly"
      )}
    </tr>
  );
}
